import * as React from 'react';
import {
  GoogleMap,
  LoadScript,
  DirectionsService,
  DirectionsRenderer,
} from '@react-google-maps/api';
import { cn } from 'lib/utils';

import { useMapHelper } from './hooks';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;
const MAP_ID = '87412a572f003751';

type Props = React.HTMLAttributes<HTMLDivElement>

export const TransportRouteMap = ({ className, ...props }: Props) => {
  const {
    mapCenter,
    googleMapsForwardDirectionsOptions,
    googleMapsBackwardDirectionsOptions,
    handleForwardDirectionsServiceResponse,
    handleBackwardDirectionsServiceResponse,
    forwardTripDirections,
    backwardTripDirections,
  } = useMapHelper();

  if (!mapCenter) return null;

  return (
    <div {...props} className={cn('w-full h-[715px] rounded-md overflow-hidden', className)}>
      <LoadScript googleMapsApiKey={API_KEY} mapIds={[MAP_ID]}>
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          zoom={10}
          options={{ mapId: MAP_ID, scrollwheel: false, zoomControl: true }}
          center={mapCenter}
        >
          {googleMapsForwardDirectionsOptions && (
            <DirectionsService
              options={googleMapsForwardDirectionsOptions}
              callback={handleForwardDirectionsServiceResponse}
            />
          )}
          {forwardTripDirections && (
            <DirectionsRenderer options={{
              directions: forwardTripDirections,
              polylineOptions: {
                strokeColor: '#ab2884',
                zIndex: 2,
              },
            }} />
          )}
          {googleMapsBackwardDirectionsOptions && (
            <DirectionsService
              options={googleMapsBackwardDirectionsOptions}
              callback={handleBackwardDirectionsServiceResponse}
            />
          )}
          {backwardTripDirections && (
            <DirectionsRenderer options={{
              directions: backwardTripDirections,
              polylineOptions: {
                strokeColor: '#475569',
                zIndex: 1,
              },
            }} />
          )}
        </GoogleMap>
      </LoadScript>
    </div>

  );
};